import * as Yup from "yup"

export const validationFormThemesInterest = Yup.object().shape({
  title: Yup.string().required("Campo obligatorio.").max(40, "Máximo 40 caracteres"),
  description: Yup.string().required("Campo obligatorio.").max(200, "Máximo 200 caracteres"),
  url: Yup.string().required("Campo obligatorio.").max(30, "Máximo 30 caracteres"),
})
